/* COSMOKID — JS propio, vanilla. Cada init comprueba que su elemento exista. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.ck-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('ck-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('ck-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initParallax() {
    var heroes = document.querySelectorAll('[data-ck-parallax]');
    if (!heroes.length || reduce) return;
    var ticking = false;
    function update() {
      ticking = false;
      heroes.forEach(function (h) {
        var r = h.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var k = parseFloat(h.getAttribute('data-ck-parallax')) || 0.12;
        var offset = Math.max(-60, Math.min(60, -r.top * k));
        h.style.setProperty('--ck-par', offset.toFixed(1) + 'px');
      });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  function initGallery() {
    document.querySelectorAll('[data-ck-gallery]').forEach(function (g) {
      var imgs = g.querySelectorAll('.ck-gal__main img');
      var thumbs = g.querySelectorAll('.ck-gal__thumb');
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
          thumbs.forEach(function (tt, j) { tt.classList.toggle('is-on', j === i); });
        });
      });
    });
  }

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return (fmt || '{{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function initBuy() {
    document.querySelectorAll('[data-ck-buy]').forEach(function (root) {
      var jsonEl = root.querySelector('[data-ck-variants]');
      if (!jsonEl) return;
      var variants = JSON.parse(jsonEl.textContent);
      var fmt = root.getAttribute('data-money');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-ck-price]');
      var btn = root.querySelector('[data-ck-add]');
      var labelAdd = btn ? btn.getAttribute('data-label-add') : '';
      var labelSold = btn ? btn.getAttribute('data-label-sold') : '';

      function current() {
        var chosen = [];
        root.querySelectorAll('[data-ck-opt]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          chosen.push(c ? c.value : null);
        });
        return variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      }
      function update() {
        var v = current();
        if (!v) { if (btn) { btn.disabled = true; btn.textContent = labelSold; } return; }
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = money(v.price, fmt) + (v.compare > v.price ? ' <s>' + money(v.compare, fmt) + '</s>' : '');
        }
        if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? labelAdd : labelSold; }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
      root.querySelectorAll('[data-ck-opt] input').forEach(function (i) { i.addEventListener('change', update); });

      var qty = root.querySelector('[data-ck-qty]');
      if (qty) {
        var input = qty.querySelector('input');
        qty.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n += b.getAttribute('data-dir') === '+' ? 1 : -1;
            input.value = Math.max(1, n);
          });
        });
      }
    });
  }

  function init() {
    document.documentElement.classList.remove('ck-no-js');
    initReveal(); initParallax(); initGallery(); initBuy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
